module.exports = __webpack_public_path__ + "img/house-projects-3.ba2ac132.jpg";